import api from '../services/api'
// t478 · las demás cuentas abiertas en este dispositivo (como Gmail): cerrar una no suelta los avisos de las otras.
import { idsDeLasDormidas } from '../utils/cuentasDelDispositivo'

// ══════════════════════════════════════════════════════════════════════════════════════════════
//  B-834 · AL CERRAR SESIÓN, ESTE EQUIPO DEJA DE RECIBIR LOS AVISOS DE QUIEN SE VA        (25-sep-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño: «asegúrate que no lleguen notificaciones a otros doctores de consentimientos que no les corresponde». En el
//  ordenador (o la tableta) compartido del gabinete, cerrar sesión no daba de baja el aviso push: el equipo seguía
//  recibiendo los del doctor anterior —con el nombre del paciente— hasta que entrara otra cuenta. La ruta de baja ya
//  existía (DELETE /api/push/registrar) y no la llamaba nadie.
//
//  Se llama desde `logout` (context/AuthContext.jsx) ANTES de limpiar la sesión: la baja necesita la sesión que se va, así
//  que el token se lee al empezar (antes del primer `await`) y viaja explícito. Nunca revienta ni hace esperar: si falla,
//  la sesión se cierra igual.

const CLAVE_NATIVO = 'push_token_nativo'

// El token de la app del iPhone o del Android (FCM). Solo lo conoce el dispositivo: se guarda al registrarlo
// (push/registrarPush.js) para poder darlo de baja al salir.
export function recordarTokenNativo(t) {
  try { if (t) localStorage.setItem(CLAVE_NATIVO, String(t)) } catch (_) { /* sin almacenamiento: no hay nada que dar de baja */ }
}

// t478 · Los tokens de ESTE dispositivo (el de la app del móvil y la suscripción del navegador), para soltarlos.
export async function tokensDeEsteDispositivo() {
  const tokens = []
  try { const n = localStorage.getItem(CLAVE_NATIVO); if (n) tokens.push(n) } catch (_) { /* sin almacenamiento */ }
  try {
    const reg = typeof navigator !== 'undefined' && navigator.serviceWorker && await navigator.serviceWorker.getRegistration()
    const sub = reg && reg.pushManager && await reg.pushManager.getSubscription()
    if (sub) tokens.push(JSON.stringify(sub))
  } catch (_) { /* sin service worker: nada que dar de baja por aquí */ }
  return tokens
}

export async function darDeBajaEsteEquipo() {
  let auth = null
  try {
    const t = localStorage.getItem('token')
    if (t) auth = 'Bearer ' + t
  } catch (_) { return }
  if (!auth) return
  // t478 · las que SIGUEN abiertas en este dispositivo (utils/cuentasDelDispositivo): sus avisos no se sueltan. Sin ninguna,
  // la lista va vacía y el servidor suelta el token entero, como siempre.
  let siguen = []
  try { siguen = idsDeLasDormidas() } catch (_) { siguen = [] }
  const tokens = await tokensDeEsteDispositivo()
  for (const token of tokens) {
    try { await api.delete('/push/registrar', { data: { token, ...(siguen.length ? { siguen } : {}) }, headers: { Authorization: auth } }) } catch (_) { /* la sesión se cierra igual */ }
  }
}
